import { Alert, Button, Box, Grid } from "@mui/material";
import AgendamentoList from "../../Agendamento/List";
import { Link } from "react-router-dom";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import { useList } from "../useList";
import LinearProgress from "@mui/material/LinearProgress";
import { LoadingButton } from "../../../components/Loading";
import { useInit } from "../../Router/InitContext";
import { useAuth } from "../../Auth/AuthContext";
import { ProfissionalSetor } from "../../ProfissionalSetor/ProfissionalSetor";

export function Realizados() {
  const {
    setorAtendimentoFromUser,
    profissionais,
    isLoading: isLoadingInit,
  } = useInit();
  const { user } = useAuth();

  const {
    agendamentos: atendimentos,
    isLoading,
    loadMore,
    hasMore,
    setSetorAtendimento,
    setorAtendimento,
    profissional,
    setProfissional,
  } = useList({
    isAgendamento: false,
    initialProfissional: profissionais.find((p) => p.user?.id === user.user.id),
    initialSetorAtendimento: setorAtendimentoFromUser,
    enabled: !isLoadingInit,
    sorting: "dataAtendimento:desc",
  });

  return (
    <>
      <Grid container mb={2} spacing={2}>
        <ProfissionalSetor
          gridSetorProps={{ xs: 12, sm: 6, md: 4 }}
          textFieldSetorProps={{
            label: "Filtro por setor",
          }}
          textFieldProfissionalProps={{
            label: "Filtro por profissional",
          }}
          gridProfissionalProps={{ xs: 12, sm: 6, md: 4 }}
          setorAtendimento={setorAtendimento || ""}
          onChangeSetor={(e, setorAtendimento) =>
            setSetorAtendimento(setorAtendimento)
          }
          profissional={profissional}
          onChangeProfissional={(e, profissional) =>
            setProfissional(profissional)
          }
        />
      </Grid>
      {atendimentos.length > 0 && (
        <AgendamentoList
          agendamentos={atendimentos}
          actions={(a) => (
            <Button
              LinkComponent={Link}
              to={`/grupo/atendimento/${a.id}`}
              startIcon={<FindInPageIcon />}
              title="Visualizar atendimento"
            >
              Visualizar
            </Button>
          )}
        />
      )}

      {(isLoading || isLoadingInit) && <LinearProgress />}

      {!isLoading && !isLoadingInit && atendimentos.length === 0 && (
        <Alert severity="info">Nenhum atendimento realizado</Alert>
      )}
      {hasMore && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <LoadingButton
            onClick={loadMore}
            variant="text"
            color="primary"
            loading={isLoading}
          >
            Carregar mais ...
          </LoadingButton>
        </Box>
      )}
    </>
  );
}
